import styled from 'styled-components'

export const MeetingRoomGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 16rem));
  gap: 24px;
  margin-top: 24px;
`

export const StatusBadge = styled.div<{ $isAvailable: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 0.75rem;
  color: ${({ $isAvailable }) => ($isAvailable ? '#464646' : '#d93025')};

  svg {
    color: ${({ $isAvailable }) => ($isAvailable ? '#f7941e' : '#d93025')};
  }
`
